'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _components = require('../../../components');
var _InlineGallery = require('./InlineGallery.scss');var styles = _interopRequireWildcard(_InlineGallery);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}

var smImg = 292;
var bgImg = 585;
var modalWidth = 930;
var scrollWidth = 15;var

InlineGallery = function (_Component) {_inherits(InlineGallery, _Component);
  function InlineGallery(props) {_classCallCheck(this, InlineGallery);var _this = _possibleConstructorReturn(this,
    _Component.call(this, props));_initialiseProps.call(_this);
    _this.state = {
      offset: 0,
      galleryWidth: _this.calcGalleryWidth(props) };return _this;

  }InlineGallery.prototype.

  componentDidMount = function componentDidMount() {
    this.screenWidth = this.props.isModal && window.innerWidth >= modalWidth ?
    modalWidth - scrollWidth :
    window.innerWidth;
  };InlineGallery.prototype.































  renderGallery = function renderGallery() {var _this2 = this;
    this.maxLeft = this.state.galleryWidth - this.screenWidth;
    this.stepWidth = this.screenWidth - this.screenWidth % smImg;

    return this.props.images.map(function (img, idx) {return (
        _react2.default.createElement('div', {
            key: img.thumbnail,
            onClick: function onClick() {return _this2.props.openLightbox(idx);},
            className: styles.item },

          _react2.default.createElement('img', {
            alt: '',
            src: _this2.qualityImprovement(idx === 0 ? _this2.resolutionImprovement(_this2.props.thumbnail) : img.thumbnail) })));});



  };InlineGallery.prototype.




































  render = function render() {var _cx,_this3 = this;var _props =
    this.props,isRtl = _props.isRtl,images = _props.images,videos = _props.videos;
    var isSingleItem = images.length + videos.length === 1;
    return (
      _react2.default.createElement('div', { className: styles.wrapper },
        _react2.default.createElement(_components.GalleryArrow, {
          position: isRtl ? 'left' : 'right',
          handleClick: this.scrollForward,
          isShown: this.state.galleryWidth > this.screenWidth && this.state.offset !== this.maxLeft,
          className: 'inlineGalleryArrow' }),

        _react2.default.createElement(_components.GalleryArrow, {
          position: isRtl ? 'right' : 'left',
          handleClick: this.scrollBack,
          isShown: this.state.offset > 0,
          className: 'inlineGalleryArrow' }),

        _react2.default.createElement('div', {
            className: (0, _classnames2.default)(styles.container, (_cx = {}, _cx[styles.singleItem] = isSingleItem, _cx)),
            ref: function ref(scrollableAria) {_this3.scrollableAria = scrollableAria;},
            style: { width: isSingleItem ? '100%' : this.state.galleryWidth + 'px' } },

          this.renderGallery(),
          this.renderVideos()),

        this.renderVideoDirectLinkButton()));


  };return InlineGallery;}(_react.Component);var _initialiseProps = function _initialiseProps() {var _this4 = this;this.calcGalleryWidth = function (props) {var imagesLength = (0, _get2.default)(props, 'images.length') || 0;var videosLength = (0, _get2.default)(props, 'videos.length') || 0;var smallImagesSize = Math.floor((imagesLength + videosLength) / 2) * smImg;return bgImg + smallImagesSize;};this.scrollForward = function () {if (_this4.state.offset < _this4.state.galleryWidth) {var length = _this4.state.offset + _this4.stepWidth * 2;var offset = length >= _this4.state.galleryWidth ? _this4.maxLeft : _this4.state.offset + _this4.stepWidth;_this4.scrollableAria.style.left = '' + (_this4.props.isRtl ? '' : '-') + offset + 'px';_this4.setState({ offset: offset });}};this.scrollBack = function () {if (_this4.state.offset !== 0) {var offset = _this4.state.offset >= _this4.stepWidth ? _this4.state.offset - _this4.stepWidth : 0;_this4.scrollableAria.style.left = '' + (_this4.props.isRtl ? '' : '-') + offset + 'px';_this4.setState({ offset: offset });}};this.resolutionImprovement = function (img) {return img.replace('350', '585').replace('264', '440');};this.qualityImprovement = function (img) {return img.replace('f_auto', 'f_auto,q_auto');};this.renderVideos = function () {var videos = _this4.props.videos;if (!videos || !videos.length) {return null;}return videos.map(function (_ref) {var thumbnail = _ref.thumbnail;return _react2.default.createElement('div', { key: thumbnail, onClick: function onClick() {return _this4.props.openLightbox(_this4.props.images.length);}, className: (0, _classnames2.default)(styles.item, styles.video) }, _react2.default.createElement('img', { alt: '', src: thumbnail }), _react2.default.createElement('span', { className: 'icon icon-video' }));});};this.renderVideoDirectLinkButton = function () {var videos = _this4.props.videos;if (!videos || !videos.length) {return null;}return _react2.default.createElement('span', { onClick: function onClick() {return _this4.props.openLightbox(_this4.props.images.length);}, className: (0, _classnames2.default)('icon icon-gallery-video', styles.videoLink) }, _react2.default.createElement('span', { className: 'path1' }), _react2.default.createElement('span', { className: 'path2' }));};};exports.default = InlineGallery;


InlineGallery.propTypes = {
  thumbnail: _propTypes2.default.string,
  images: _propTypes2.default.array,
  videos: _propTypes2.default.array,
  isModal: _propTypes2.default.bool,
  openLightbox: _propTypes2.default.func,
  isRtl: _propTypes2.default.bool };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/InlineGallery/InlineGallery.js
// module id = 2848
// module chunks = 0